export const responseHandler = (response) => {
  return response.text().then((text) => {
    const data = text ? JSON.parse(text) : null;
    if (!response.ok) {
      return Promise.reject({
        status: response.status,
        statusText: response.statusText,
        message: data && data.message ? data.message : "Undefined Error",
      });
    }
    return data;
  });
};
